import useJwt from '@/auth/jwt/useJwt'

/**
 * Güvenli kullanıcı giriş kontrolü
 * - Token geçerliliğini kontrol eder
 * - localStorage güvenliğini sağlar
 */
export const isUserLoggedIn = () => {
  try {
    const userData = localStorage.getItem('userData')
    const accessToken = localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)

    // Temel kontroller
    if (!userData || !accessToken) return false
    if (userData === 'undefined' || userData === 'null') return false
    if (accessToken === 'undefined' || accessToken === 'null') return false

    // Token geçerliliğini kontrol et
    return isTokenValid(accessToken)
  } catch (error) {
    console.error('Error checking user login status:', error)
    return false
  }
}

/**
 * Güvenli userData okuma
 * - JSON parse hatalarını yakalar
 * - Güvenlik kontrolleri yapar
 */
export const getUserData = () => {
  try {
    const userData = localStorage.getItem('userData')
    if (!userData || userData === 'undefined' || userData === 'null') {
      return null
    }
    return JSON.parse(userData)
  } catch (error) {
    console.error('Error parsing user data:', error)
    // Hatalı veri varsa temizle
    localStorage.removeItem('userData')
    localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
    return null
  }
}

/**
 * Token geçerliliğini kontrol et
 * @param {string} token - JWT token
 * @returns {boolean} - Token geçerli mi?
 */
function isTokenValid(token) {
  if (!token) return false

  try {
    // JWT token formatını kontrol et
    const parts = token.split('.')
    if (parts.length !== 3) return false

    // Payload'ı decode et
    const payload = JSON.parse(atob(parts[1]))
    const currentTime = Math.floor(Date.now() / 1000)

    // Token süresi dolmuş mu?
    if (payload.exp && payload.exp < currentTime) {
      console.warn('Token expired')
      return false
    }

    return true
  } catch (error) {
    console.error('Invalid token format:', error)
    return false
  }
}

/**
 * This function is used for demo purpose route navigation
 * In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 * Please note role field is just for showing purpose it's not used by anything in frontend
 * We are checking role just for ease
 * NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  // Giriş yapmış tüm kullanıcıları ana sayfaya yönlendir
  // (Rol bazlı farklı dashboard'lar eklemek istersen burayı genişletebilirsin)
  if (userRole === 'admin') return { name: 'home' }
  if (userRole === 'client') return { name: 'home' }

  // Diğer tüm roller için de varsayılan olarak ana sayfaya git
  return { name: 'home' }
}
